export function formatMoney(price: string | number): string {
  const priceAsNumber = Number(price);
  const priceAfterAdjustment = priceAsNumber;

  const finalPrice = `${Number(priceAfterAdjustment.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

  return theme.currencySymbol.replace('{{amount}}', finalPrice).replace('{{amount_with_comma_separator}}', finalPrice);
}
